import React from 'react';
import {Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, ButtonToolbar} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import * as TextManager from "../../modules/languages/TextManager";
import {fetchEquipmentDataIfNeeded} from "../../redux/actions/EquipmentActions";
import {fetchSalesDataIfNeeded} from "../../redux/actions/SalesActions";
import classnames from 'classnames';
import DateSelector from '../../components/DateSelector'

import EquipmentList from './components/EquipmentList'
import EquipmentStoreTable from './components/EquipmentStoreTable'
import EquipmentTableOrdersJson from './components/EquipmentTableOrdersJson'
import EquipmentCategories from './components/EquipmentCategories'
import EquipmentStoreTableManagers from './components/EquipmentStoreTableManagers'
import EquipmentManagersProfit from './components/EquipmentManagersProfit'
import MultiSelectionFilter from "./components/MultiSelectionFilter";


const statusLst = [
    {value: 1, label: TextManager.getCurrentTextResource().Text.new},
    {value: 2, label: TextManager.getCurrentTextResource().Text.inactive},
    {value: 3, label: TextManager.getCurrentTextResource().Text.active}];

export class Orders extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            activeTab: '1',
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchEquipmentDataIfNeeded(this.queryParams));
        this.props.dispatch(fetchSalesDataIfNeeded());
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'number') {
                    if (parseInt(this.state.searchValue) === mr) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {

        let isStore = true;
        if (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.isAdmin || this.props.userData.data.isManager)) {
            isStore = false;
        }

        let isManager = false;
        if (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.id === 548 || this.props.userData.data.id === 683 || this.props.userData.data.id === 1007)) {
            isManager = true;
        }

        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin || this.props.userData.data.id === 795)) {
            isAdmin = true;
        }

        /*let data = [];
        let dataStores = [];
        let dataManagers = [];

        if(this.props.data && this.props.data.equipOrders) {

            //console.log(this.props.data.equipOrders)
            if(isStore) {
                data = this.props.data.equipOrders.filter(e => e.storeId === this.props.userData.data.id);
            }
            else if(isManager) {
                data = this.props.data.equipOrders;
            }
            else {
                dataManagers = this.props.data.equipOrders.filter((e) => (e.storeId === 31 || e.storeId === 118 || e.storeId === 548 || e.storeId === 683));
                dataStores = this.props.data.equipOrders.filter((e) => (e.storeId !== 31 && e.storeId !== 118 && e.storeId !== 548 && e.storeId !== 683));
            }
        }*/

        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    {isStore &&
                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <div className="card__title">
                                        <h3 style={{textAlign: 'right'}}>הזמנת ציוד קצה</h3>
                                    </div>
                                    <div className="tabs tabs--bordered-top">
                                        <div className="tabs__wrap" style={{direction: 'rtl'}}>
                                            <Nav tabs>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '1'})}
                                                        onClick={() => {
                                                            this.toggle('1');
                                                        }}
                                                    >
                                                        הזמנות ציוד קצה
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '2'})}
                                                        onClick={() => {
                                                            this.toggle('2');
                                                        }}
                                                    >
                                                        היסטוריה של הזמנות
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={this.state.activeTab}>
                                                <TabPane tabId="1" style={{direction: 'ltr'}}>
                                                    <EquipmentCategories/>
                                                </TabPane>
                                                <TabPane tabId="2" style={{direction: 'ltr'}}>
                                                    <EquipmentTableOrdersJson/>
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    }
                    {isManager &&
                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <div className="card__title">
                                        <h3 style={{textAlign: 'right'}}>הזמנת ציוד קצה</h3>
                                    </div>
                                    <div className="tabs tabs--bordered-top">
                                        <div className="tabs__wrap" style={{direction: 'rtl'}}>
                                            <Nav tabs>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '1'})}
                                                        onClick={() => {
                                                            this.toggle('1');
                                                        }}
                                                    >
                                                        הזמנות ציוד קצה
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '2'})}
                                                        onClick={() => {
                                                            this.toggle('2');
                                                        }}
                                                    >
                                                        להזמין ציוד קצה
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '3'})}
                                                        onClick={() => {
                                                            this.toggle('3');
                                                        }}
                                                    >
                                                        מלאי נוכחי
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={this.state.activeTab}>
                                                <TabPane tabId="1" style={{direction: 'ltr'}}>
                                                    <EquipmentTableOrdersJson/>
                                                </TabPane>
                                                <TabPane tabId="2" style={{direction: 'ltr'}}>
                                                    <EquipmentCategories/>
                                                </TabPane>
                                                <TabPane tabId="3" style={{direction: 'ltr'}}>
                                                    <EquipmentStoreTable data={this.props.data.equipStore}/>
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>}
                    {isAdmin &&
                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <div className="card__title">
                                        <h3 style={{textAlign: 'right'}}>הזמנת ציוד קצה</h3>
                                    </div>
                                    <div style={{padding: "1.25rem"}}>
                                        {(this.state.activeTab === '1' || this.state.activeTab === '2') && <div style={{display: 'flex', height: '100%', width: '70%'}}>
                                            <ButtonToolbar className='custom_dashboard_header_panel'>
                                                <DateSelector endpoint='equipments'/>
                                                {this.state.activeTab === '1' && <MultiSelectionFilter items={statusLst} name="סטטוס" queryParam="status"/>}
                                            </ButtonToolbar>
                                        </div> }
                                    </div>
                                    <div className="tabs tabs--bordered-top">
                                        <div className="tabs__wrap" style={{direction: 'rtl'}}>
                                            <Nav tabs>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '1'})}
                                                        onClick={() => {
                                                            this.toggle('1');
                                                        }}
                                                    >
                                                         הזמנות ציוד קצה חנויות
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '2'})}
                                                        onClick={() => {
                                                            this.toggle('2');
                                                        }}
                                                    >
                                                        הזמנות ציוד קצה מנהלים
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '3'})}
                                                        onClick={() => {
                                                            this.toggle('3');
                                                        }}
                                                    >
                                                        ציוד קצה
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '4'})}
                                                        onClick={() => {
                                                            this.toggle('4');
                                                        }}
                                                    >
                                                        מלאי נוכחי
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '5'})}
                                                        onClick={() => {
                                                            this.toggle('5');
                                                        }}
                                                    >
                                                        קליטת ציוד קצה
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === '6'})}
                                                        onClick={() => {
                                                            this.toggle('6');
                                                        }}
                                                    >
                                                        רווח על מנג'ר
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={this.state.activeTab}>
                                                <TabPane tabId="1" style={{direction: 'ltr'}}>
                                                    <EquipmentTableOrdersJson stores={true}/>
                                                </TabPane>
                                                <TabPane tabId="2" style={{direction: 'ltr'}}>
                                                    <EquipmentTableOrdersJson managers={true}/>
                                                </TabPane>
                                                <TabPane tabId="3" style={{direction: 'ltr'}}>
                                                    <EquipmentList/>
                                                </TabPane>
                                                <TabPane tabId="4" style={{direction: 'ltr'}}>
                                                    <EquipmentStoreTableManagers/>
                                                </TabPane>
                                                <TabPane tabId="5" style={{direction: 'ltr'}}>
                                                    <EquipmentStoreTable data={this.props.data.equipStore}/>
                                                </TabPane>
                                                <TabPane tabId="6" style={{direction: 'ltr'}}>
                                                    <EquipmentManagersProfit/>
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>}
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        data: state.equipment.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(Orders))